import { useState, useEffect } from "react";
import React from "react";
import { getPlaceOfissue, getEmployeePassportInfo, PostEmployeePassportInfo, PostEmployeeVisaInfo, getEmployeeVisaInfo, getNotificationId } from "../service/DirectorAPI";
import moment from "moment";
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import $ from 'jquery';
import { connect } from 'react-redux'
import { encryptStorage } from '../constant'

function PassportDetail(props) {

    let dataObj = {
        id: "",
        NameInPassport: "",
        PassportNumber: "",
        DateOfIssue: "",
        DateOfExpiry: "",
        PlaceOfIssue: "",
        Ecnr: "",
        doyouhavevisa: 0
    };

    let visaData = {
        id: "",
        VisaNumber: "",
        VisaType: "",
        DateOfIssue: "",
        DateOfExpiry: "",
        Country: ""

    }

    const [passportData, setpassportData] = useState(dataObj);
    const [visaDetail, setVisaDetail] = useState(visaData);

    let dropDownArrayPlaceOfIssue = [];
    const [arrDropDownplaceofissue, setarrDropDownplaceofissue] = useState(dropDownArrayPlaceOfIssue);

    let oldvalue = {
        NameInPassport: "",
        PassportNumber: "",
        DateOfIssue: "",
        DateOfExpiry: "",
        PlaceOfIssue: "",
        Ecnr: ""
    }

    let oldVisa = {
        VisaNumber: "",
        VisaType: "",
        DateOfIssue: "",
        DateOfExpiry: "",
        Country: ""

    }
    let EditArray = [];
    const [editArray, seteditArray] = useState(EditArray);

    const [Oldvalue, setOldvalue] = useState(oldvalue);
    const [OldVisa, setOldVisa] = useState(oldVisa);

    const [pagemode, setpagemode] = useState("false");
    const [viewmode, setviewmode] = useState("false");
    const [EmpId, setEmpId] = useState("");
    const [submit, setSubmit] = useState("Save");
    const [selectedFile, setselectedFile] = useState("");
    const [showPassport, setShowPassport] = useState(true);
    const [showVisa, setShowVisa] = useState(true);
    const [editSection, setEditSection] = useState("");
    const [notification, setNotification] = useState([]);
    const [hideForm, setHideForm] = useState(true);
    const [reportstoId, setReportstoId] = useState("");
    const [showCheckBox, setShowCheckBox] = useState(true);
const [DisableSubmitBtn, setDisableSubmitBtn] = useState(false);
    let loginEmpId = encryptStorage.getItem("employeeId");
    let role = encryptStorage.getItem("role");


    useEffect(() => {
        setDisableSubmitBtn(false);

        if (props.IsPassportClicked) {

            // let element = document.getElementById("removeScroll");
            // element.classList.add("removeScroll");

            $("body").addClass("removeScroll");
            setHideForm(false);

            LoadPlaceOfIssue();
            setEditSection(props.EditSection);

            //props.passportCount > 0 ? setShowPassport(false) : setShowPassport(true)


            if (props.passportCount > 0) {
                setShowPassport(false);
                setShowVisa(true);
            } else {
                setShowPassport(true);
                setShowVisa(false);
            }

            if (props.empId != undefined) {
                setEmpId(props.empId)
            }
            if (props.Mode != undefined) {
                if (props.Mode == 'Edit') {
                    props.EditSection == 'Passport' ? setShowPassport(true) : setShowPassport(false);
                    props.EditSection == 'Passport' ? setShowCheckBox(false) : setShowCheckBox(true);
                    props.EditSection == 'Visa' ? setShowVisa(true) : setShowVisa(false);
                    setpagemode('true')
                    setSubmit('Update')
                } else {
                    setpagemode('false')
                    setSubmit('Save')
                }
            }
            if (props.Id != undefined) {

                let objedit = {

                    emp_id: props.empId,
                    id: props.Id,
                    reports_to: loginEmpId,
                    role: role,
                };

                let editSection = props.EditSection

                selecteditarray(objedit, editSection);
            }
        }

    }, [props])

    const OnChangeName = (e) => {
        setpassportData({ ...passportData, [e.target.name]: e.target.value });
        setmessage({ ...message, [e.target.name]: "" });
    };

    const VisaOnChangeName = (e) => {
        setVisaDetail({ ...visaDetail, [e.target.name]: e.target.value });
        setErrormessage({ ...errormessage, [e.target.name]: "" });
    };

    const OnClickEcnr = (e) => {

        if ((passportData.Ecnr == "Stamped" && e.target.id == "Stamped") || (passportData.Ecnr == "Yet to Stamp" && e.target.id == "Yet to Stamp")) {
            setpassportData({ ...passportData, [e.target.name]: "" });
        } else {
            setpassportData({ ...passportData, [e.target.name]: e.target.id });
        }

        // message.Ecnr = ""
        // setmessage({ ...message });
    };



    const LoadPlaceOfIssue = async () => {
        let PlaceOfIssueData = {};
        let responsedata = await getPlaceOfissue(PlaceOfIssueData);
        setarrDropDownplaceofissue(responsedata.data.ResponseData[0]);

    };

    const buildPlaceOfIssue = () => {
        return arrDropDownplaceofissue.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };


    let validationFields = {
        NameInPassport: "",
        PassportNumber: "",
        DateOfIssue: "",
        DateOfExpiry: "",
        PlaceOfIssue: "",
        Ecnr: ""

    }

    let visaValidationFields = {
        VisaNumber: "",
        VisaType: "",
        DateOfIssue: "",
        DateOfExpiry: "",
        Country: ""
    }
    const [message, setmessage] = useState(validationFields);
    const [errormessage, setErrormessage] = useState(visaValidationFields);
    const validation = () => {



        if (showPassport == true) {

            if (passportData.NameInPassport.trim() == "") {

                message.NameInPassport = "Name as in passport is required"
                setmessage({ ...message });
            } else {
                message.NameInPassport = ""
                setmessage({ ...message });

                let checkregex = OnlyNumberSpecialChar(passportData.NameInPassport)
                if (checkregex) {

                    message.NameInPassport = "Enter a Valid Name as in passport"
                    setmessage({ ...message });
                } else {
                    message.NameInPassport = ""
                    setmessage({ ...message });

                }

            }
            if (passportData.PassportNumber.trim() == "") {

                message.PassportNumber = "Passport Number is required"
                setmessage({ ...message });

            } else {
                message.PassportNumber = ""
                setmessage({ ...message });

            }
            if (passportData.DateOfIssue == "") {

                message.DateOfIssue = "Date of issue is required"
                setmessage({ ...message });

            } else {
                message.DateOfIssue = ""
                setmessage({ ...message });

            }
            if (passportData.DateOfExpiry == "") {

                message.DateOfExpiry = "Date of expiry is required"
                setmessage({ ...message });

            } else if (passportData.DateOfIssue != "" && passportData.DateOfExpiry != "" && passportData.DateOfExpiry <= passportData.DateOfIssue) {

                message.DateOfExpiry = "Enter a valid expiry Date"
                setmessage({ ...message });

            } else {
                message.DateOfExpiry = ""
                setmessage({ ...message });

            }
            
            // if (passportData.DateOfIssue != "" && passportData.DateOfExpiry != "" && passportData.DateOfExpiry <= passportData.DateOfIssue) {

            //     message.DateOfExpiry = "Enter a valid expiry Date"
            //     setmessage({ ...message });

            // } else {
            //     message.DateOfExpiry = ""
            //     setmessage({ ...message });

            // }




            if (passportData.PlaceOfIssue == "" || passportData.PlaceOfIssue == "select") {

                message.PlaceOfIssue = "Place of issue is required"
                setmessage({ ...message });

            } else {
                message.PlaceOfIssue = ""
                setmessage({ ...message });

            }

            // if (passportData.Ecnr == "") {

            //     message.Ecnr = "ECNR is required"
            //     setmessage({ ...message });

            // } else {
            //     message.Ecnr = ""
            //     setmessage({ ...message });

            // }
        }


        if (showVisa == true) {
            if (visaDetail.VisaNumber.trim() == "") {

                errormessage.VisaNumber = "Visa number is required"
                setErrormessage({ ...errormessage });
            } else {
                errormessage.VisaNumber = ""
                setErrormessage({ ...errormessage });

            }

            if (visaDetail.VisaType.trim() == "") {

                errormessage.VisaType = "Visa type is required"
                setErrormessage({ ...errormessage });
            } else {
                errormessage.VisaType = ""
                setErrormessage({ ...errormessage });

                let checkregex = OnlyNumberSpecialChar(visaDetail.VisaType)
                if (checkregex) {

                    errormessage.VisaType = "Enter a Valid Visa type"
                    setErrormessage({ ...errormessage });
                } else {
                    message.VisaType = ""
                    setErrormessage({ ...errormessage });

                }

            }

            if (visaDetail.DateOfIssue == "") {

                errormessage.DateOfIssue = "Date of issue is required"
                setErrormessage({ ...errormessage });
            } else {
                errormessage.DateOfIssue = ""
                setErrormessage({ ...errormessage });

            }

            if (visaDetail.DateOfExpiry == "") {

                errormessage.DateOfExpiry = "Date of expiry is required"
                setErrormessage({ ...errormessage });
            } else if (visaDetail.DateOfIssue != "" && visaDetail.DateOfExpiry != "" && visaDetail.DateOfExpiry <= visaDetail.DateOfIssue) {

                errormessage.DateOfExpiry = "Enter a valid expiry Date"
                setmessage({ ...message });

            } else {
                errormessage.DateOfExpiry = ""
                setmessage({ ...message });

            }


            // if (visaDetail.DateOfIssue != "" && visaDetail.DateOfExpiry != "" && visaDetail.DateOfExpiry <= visaDetail.DateOfIssue) {

            //     errormessage.DateOfExpiry = "Enter a valid expiry Date"
            //     setmessage({ ...message });

            // } else {
            //     errormessage.DateOfExpiry = ""
            //     setmessage({ ...message });

            // }

            if (visaDetail.Country.trim() == "") {

                errormessage.Country = "Country is required"
                setErrormessage({ ...errormessage });
            } else {
                errormessage.Country = ""
                setErrormessage({ ...errormessage });

                let checkregex = OnlyNumberSpecialChar(visaDetail.Country)
                if (checkregex) {

                    errormessage.Country = "Enter a Valid Country"
                    setErrormessage({ ...errormessage });
                } else {
                    message.Country = ""
                    setErrormessage({ ...errormessage });

                }

            }
        }

    }

    const cancelClick = () => {

        let valiclearoption = {
            id: "",
            NameInPassport: "",
            PassportNumber: "",
            DateOfIssue: "",
            DateOfExpiry: "",
            PlaceOfIssue: "",
            Ecnr: "",
            doyouhavevisa: ""
        };
        setpassportData(valiclearoption);


        let validationFields = {
            NameInPassport: "",
            PassportNumber: "",
            DateOfIssue: "",
            DateOfExpiry: "",
            PlaceOfIssue: "",
            Ecnr: ""

        }
        setmessage(validationFields);

        let visaValidationFields = {
            VisaNumber: "",
            VisaType: "",
            DateOfIssue: "",
            DateOfExpiry: "",
            Country: ""
        }
        setErrormessage(visaValidationFields);

        let visaData = {
            id: "",
            VisaNumber: "",
            VisaType: "",
            DateOfIssue: "",
            DateOfExpiry: "",
            Country: ""

        }

        setVisaDetail(visaData);
        props.setIsPassportClicked(false);
        setHideForm(true);
        setShowVisa(true);
        // let element = document.getElementById("removeScroll");
        // element.classList.remove("removeScroll");
        $("body").removeClass("removeScroll");
    }


    const handleChecked = (e) => {

        e.target.checked == true
            ? setShowVisa(true)
            : setShowVisa(false);

        e.target.checked == true
            ? setpassportData({ ...passportData, [e.target.name]: 1 })
            : setpassportData({ ...passportData, [e.target.name]: 0 });

        // e.target.checked == true
        //     ? setCurrentAsPermanentValue()
        //     : clearPermanentValue();



        //setHideVisa(true);


    };



    const submitClick = async () => {

        try {
              setDisableSubmitBtn(true);

            validation();

            let isPassportFiekdsValid = true;
            let isVisaFieldsValid = true;
            let isSubmitBoath = true;
            if (message.NameInPassport != "" || message.DateOfIssue != "" || message.DateOfExpiry != "") {
                isPassportFiekdsValid = false;
            } else { isPassportFiekdsValid = true; }

            if (errormessage.VisaType != "" || errormessage.Country != "" || errormessage.DateOfExpiry != "") {
                isVisaFieldsValid = false;
            } else { isVisaFieldsValid = true; }


            if (showVisa == true && (errormessage.VisaNumber != "" || errormessage.DateOfIssue != "" || errormessage.VisaType != "" || errormessage.Country != "" || errormessage.DateOfExpiry != "")) {
                isSubmitBoath = false;
            } else {
                isSubmitBoath = true;
            }


            if (pagemode == "false") {
                if (showPassport == true /*&& showVisa == true*/ && isPassportFiekdsValid == true && isSubmitBoath == true /*&& isVisaFieldsValid == true*/) {
                    if (
                        passportData.NameInPassport.trim() != "" &&
                        passportData.PassportNumber.trim() != "" &&
                        passportData.DateOfIssue != "" &&
                        passportData.DateOfExpiry != "" &&
                        passportData.PlaceOfIssue != ""
                        //passportData.Ecnr != "" &&
                        // visaDetail.VisaNumber.trim() != "" &&
                        // visaDetail.VisaType.trim() != "" &&
                        // visaDetail.DateOfIssue != "" &&
                        // visaDetail.DateOfExpiry != "" &&
                        // visaDetail.Country.trim() != ""
                    ) {
                        let insertdata = {
                            request_type: "Insert",
                            emp_id: EmpId,
                            login_emp_id: loginEmpId,
                            role: role,
                            name_in_passport: passportData.NameInPassport,
                            passport_num: passportData.PassportNumber,
                            date_of_issue: passportData.DateOfIssue,
                            date_of_expiry: passportData.DateOfExpiry,
                            place_of_issue: passportData.PlaceOfIssue,
                            ecnr: passportData.Ecnr,
                        };

                        let responsedata = await PostEmployeePassportInfo(insertdata);
                        if (responsedata.data.status == 200) {
                            let valiclearoption = {
                                id: "",
                                NameInPassport: "",
                                PassportNumber: "",
                                DateOfIssue: "",
                                DateOfExpiry: "",
                                PlaceOfIssue: "",
                                Ecnr: "",
                                doyouhavevisa: ""
                            };
                            setpassportData(valiclearoption);

                            props.setIsPassportClicked(false);
                            props.getEmployeePassportGrid();
                            cancelClick();
                            props.showToast('Submitted', 'Submitted Succesfully');
                        }

                    }
                }

                if (showVisa == true && showPassport == true && isPassportFiekdsValid == true && isVisaFieldsValid == true) {

                    if (
                        passportData.NameInPassport.trim() != "" &&
                        passportData.PassportNumber.trim() != "" &&
                        passportData.DateOfIssue != "" &&
                        passportData.DateOfExpiry != "" &&
                        passportData.PlaceOfIssue != "" &&
                        //passportData.Ecnr != "" &&
                        visaDetail.VisaNumber.trim() != "" &&
                        visaDetail.VisaType.trim() != "" &&
                        visaDetail.DateOfIssue != "" &&
                        visaDetail.DateOfExpiry != "" &&
                        visaDetail.Country.trim() != ""
                    ) {
                        let insertdata = {
                            request_type: "Insert",
                            emp_id: EmpId,
                            login_emp_id: loginEmpId,
                            role: role,
                            visa_number: visaDetail.VisaNumber,
                            visa_type: visaDetail.VisaType,
                            date_of_issue: visaDetail.DateOfIssue,
                            date_of_expiry: visaDetail.DateOfExpiry,
                            country: visaDetail.Country,
                        };



                        let responsedata = await PostEmployeeVisaInfo(insertdata);
                        if (responsedata.data.status == 200) {
                            let valiclearoption = {
                                id: "",
                                VisaNumber: "",
                                VisaType: "",
                                DateOfIssue: "",
                                DateOfExpiry: "",
                                Country: ""
                            };
                            setVisaDetail(valiclearoption);

                            props.setIsPassportClicked(false);
                            props.getEmployeeVisaGrid();
                            cancelClick();
                            props.showToast('Submitted', 'Submitted Succesfully');
                        }

                    }

                }

                if (showVisa == true && showPassport == false && isVisaFieldsValid == true) {

                    if (
                        visaDetail.VisaNumber.trim() != "" &&
                        visaDetail.VisaType.trim() != "" &&
                        visaDetail.DateOfIssue != "" &&
                        visaDetail.DateOfExpiry != "" &&
                        visaDetail.Country.trim() != ""
                    ) {
                        let insertdata = {
                            request_type: "Insert",
                            emp_id: EmpId,
                            login_emp_id: loginEmpId,
                            role: role,
                            visa_number: visaDetail.VisaNumber,
                            visa_type: visaDetail.VisaType,
                            date_of_issue: visaDetail.DateOfIssue,
                            date_of_expiry: visaDetail.DateOfExpiry,
                            country: visaDetail.Country,
                        };



                        let responsedata = await PostEmployeeVisaInfo(insertdata);
                        if (responsedata.data.status == 200) {
                            let valiclearoption = {
                                id: "",
                                VisaNumber: "",
                                VisaType: "",
                                DateOfIssue: "",
                                DateOfExpiry: "",
                                Country: ""
                            };
                            setVisaDetail(valiclearoption);

                            props.setIsPassportClicked(false);
                            props.getEmployeeVisaGrid();
                            cancelClick();
                            props.showToast('Submitted', 'Submitted Succesfully');
                        }

                    }

                }
            }
            else if (pagemode == "true") {

                if (((role == "Hr Manager" || role == "Hr") && loginEmpId != EmpId) ||
                    (role == "Hr Manager" && loginEmpId == EmpId && reportstoId == loginEmpId)) {

                    if (showPassport == true && isPassportFiekdsValid == true) {
                        if (
                            passportData.NameInPassport.trim() != "" &&
                            passportData.PassportNumber.trim() != "" &&
                            passportData.DateOfIssue != "" &&
                            passportData.DateOfExpiry != "" &&
                            passportData.PlaceOfIssue != ""
                            //passportData.Ecnr != ""
                        ) {
                            let updatedata = {
                                request_type: "Update",
                                emp_id: EmpId,
                                login_emp_id: loginEmpId,
                                role: role,
                                id: passportData.id,
                                name_in_passport: passportData.NameInPassport,
                                passport_num: passportData.PassportNumber,
                                date_of_issue: passportData.DateOfIssue,
                                date_of_expiry: passportData.DateOfExpiry,
                                place_of_issue: passportData.PlaceOfIssue,
                                ecnr: passportData.Ecnr,

                            };


                            let responsedata = await PostEmployeePassportInfo(updatedata);
                            if (responsedata.data.status == 200) {

                                let valiclearoption = {
                                    id: "",
                                    NameInPassport: "",
                                    PassportNumber: "",
                                    DateOfIssue: "",
                                    DateOfExpiry: "",
                                    PlaceOfIssue: "",
                                    Ecnr: "",
                                    doyouhavevisa: ""
                                };
                                setpassportData(valiclearoption);
                                props.setIsPassportClicked(false);
                                props.getEmployeePassportGrid();
                                cancelClick();
                                props.showToast('Updated', 'Updated Succesfully');
                            }
                        }
                    }

                    if (showVisa == true && isVisaFieldsValid == true) {
                        if (
                            visaDetail.VisaNumber.trim() != "" &&
                            visaDetail.VisaType.trim() != "" &&
                            visaDetail.DateOfIssue != "" &&
                            visaDetail.DateOfExpiry != "" &&
                            visaDetail.Country.trim() != ""
                        ) {
                            let updatedata = {
                                request_type: "Update",
                                emp_id: EmpId,
                                login_emp_id: loginEmpId,
                                role: role,
                                id: visaDetail.id,
                                visa_number: visaDetail.VisaNumber,
                                visa_type: visaDetail.VisaType,
                                date_of_issue: visaDetail.DateOfIssue,
                                date_of_expiry: visaDetail.DateOfExpiry,
                                country: visaDetail.Country,

                            };


                            let responsedata = await PostEmployeeVisaInfo(updatedata);
                            if (responsedata.data.status == 200) {

                                let valiclearoption = {
                                    id: "",
                                    VisaNumber: "",
                                    VisaType: "",
                                    DateOfIssue: "",
                                    DateOfExpiry: "",
                                    Country: ""
                                };
                                setVisaDetail(valiclearoption);

                                props.setIsPassportClicked(false);
                                props.getEmployeeVisaGrid();
                                cancelClick();
                                props.showToast('Updated', 'Updated Succesfully');
                            }
                        }

                    }


                } else if (role == "Team Member" || loginEmpId == EmpId) {

                    if (showPassport == true && isPassportFiekdsValid == true) {
                        if (
                            passportData.NameInPassport.trim() != "" &&
                            passportData.PassportNumber.trim() != "" &&
                            passportData.DateOfIssue != "" &&
                            passportData.DateOfExpiry != "" &&
                            passportData.PlaceOfIssue != ""
                            //passportData.Ecnr != ""
                        ) {

                            let newvalue = {
                                name_in_passport: passportData.NameInPassport,
                                passport_num: passportData.PassportNumber,
                                date_of_issue: passportData.DateOfIssue,
                                date_of_expiry: passportData.DateOfExpiry,
                                place_of_issue: passportData.PlaceOfIssue,
                                ecnr: passportData.Ecnr,
                            }

                            let oldvalue = {
                                name_in_passport: Oldvalue.NameInPassport,
                                passport_num: Oldvalue.PassportNumber,
                                date_of_issue: Oldvalue.DateOfIssue,
                                date_of_expiry: Oldvalue.DateOfExpiry,
                                place_of_issue: Oldvalue.PlaceOfIssue,
                                ecnr: Oldvalue.Ecnr,
                            }

                            let NewValue = Object.keys(newvalue);
                            let OldValue = Object.keys(oldvalue);

                            let log_data = '{';
                            for (let i = 0; i <= NewValue.length; i++) {
                                if (newvalue[NewValue[i]] != oldvalue[OldValue[i]]) {

                                    log_data += '"' + NewValue[i] + '"' + ':' + '"' + "'" + newvalue[NewValue[i]] + "'" + ',' + "'" + oldvalue[OldValue[i]] + "'" + '"' + ',';
                                }
                                if (i == NewValue.length) {

                                    log_data = log_data.slice(0, -1);
                                    log_data = log_data + "}";
                                }
                            }

                            if (log_data != '{' && log_data != '}') {
                                let logData = JSON.parse(log_data);

                                let updatedata = {
                                    request_type: "Update",
                                    emp_id: EmpId,
                                    login_emp_id: loginEmpId,
                                    category_id: passportData.id,
                                    category: "emp_passport_detail",
                                    status: "Pending",
                                    role: "Team Member",
                                    log_data: logData

                                };

                                let emp = [];
                                notification.map((obj, index) => {

                                    emp.push(obj.emp_id);
                                });

                                if (Object.keys(logData).length > 0) {

                                    let responsedata = await PostEmployeePassportInfo(updatedata);
                                    if (responsedata.data.status == 200) {
                                        let profileRequestId = responsedata.data.ResponseData[1];
                                        await NotificationTrigger({ title: "Profile Update", message: 'Profile Request', route: '/profileupdate', state: { state: { profileRequestId: profileRequestId } }, to_employee: emp, by: loginEmpId }, emp, props.websocket)

                                        let valiclearoption = {
                                            id: "",
                                            NameInPassport: "",
                                            PassportNumber: "",
                                            DateOfIssue: "",
                                            DateOfExpiry: "",
                                            PlaceOfIssue: "",
                                            Ecnr: "",
                                            doyouhavevisa: ""
                                        };
                                        setpassportData(valiclearoption);
                                        props.setIsPassportClicked(false);
                                        cancelClick();
                                        props.showToast('Profile Request submitted', 'Changes will be reflected after the approval');
                                    }
                                }
                            } else { cancelClick(); }
                        }


                    }

                    if (showVisa == true && isVisaFieldsValid == true) {
                        if (
                            visaDetail.VisaNumber.trim() != "" &&
                            visaDetail.VisaType.trim() != "" &&
                            visaDetail.DateOfIssue != "" &&
                            visaDetail.DateOfExpiry != "" &&
                            visaDetail.Country.trim() != ""
                        ) {

                            let newvalue = {
                                visa_number: visaDetail.VisaNumber,
                                visa_type: visaDetail.VisaType,
                                date_of_issue: visaDetail.DateOfIssue,
                                date_of_expiry: visaDetail.DateOfExpiry,
                                country: visaDetail.Country
                            }

                            let oldvalue = {
                                visa_number: OldVisa.VisaNumber,
                                visa_type: OldVisa.VisaType,
                                date_of_issue: OldVisa.DateOfIssue,
                                date_of_expiry: OldVisa.DateOfExpiry,
                                country: OldVisa.Country
                            }

                            let NewValue = Object.keys(newvalue);
                            let OldValue = Object.keys(oldvalue);

                            let log_data = '{';
                            for (let i = 0; i <= NewValue.length; i++) {
                                if (newvalue[NewValue[i]] != oldvalue[OldValue[i]]) {

                                    log_data += '"' + NewValue[i] + '"' + ':' + '"' + "'" + newvalue[NewValue[i]] + "'" + ',' + "'" + oldvalue[OldValue[i]] + "'" + '"' + ',';
                                }
                                if (i == NewValue.length) {

                                    log_data = log_data.slice(0, -1);
                                    log_data = log_data + "}";
                                }
                            }

                            if (log_data != '{' && log_data != '}') {
                                let logData = JSON.parse(log_data);

                                let updatedata = {
                                    request_type: "Update",
                                    emp_id: EmpId,
                                    login_emp_id: loginEmpId,
                                    category_id: visaDetail.id,
                                    category: "emp_visa_detail",
                                    status: "Pending",
                                    role: "Team Member",
                                    log_data: logData

                                };

                                let emp = [];
                                notification.map((obj, index) => {

                                    emp.push(obj.emp_id);
                                });

                                if (Object.keys(logData).length > 0) {

                                    let responsedata = await PostEmployeePassportInfo(updatedata);
                                    if (responsedata.data.status == 200) {
                                        let profileRequestId = responsedata.data.ResponseData[1];
                                        await NotificationTrigger({ title: "Profile Update", message: 'Profile Request', route: '/profileupdate', state: { state: { profileRequestId: profileRequestId } }, to_employee: emp, by: loginEmpId }, emp, props.websocket)

                                        let valiclearoption = {
                                            id: "",
                                            VisaNumber: "",
                                            VisaType: "",
                                            DateOfIssue: "",
                                            DateOfExpiry: "",
                                            Country: ""
                                        };
                                        setVisaDetail(valiclearoption);
                                        props.setIsPassportClicked(false);
                                        cancelClick();
                                        props.showToast('Profile Request submitted', 'Changes will be reflected after the approval');
                                    }
                                }
                            } else { cancelClick(); }
                        }
                    }
                }
            }
             setDisableSubmitBtn(false);
        } catch (e) {
             setDisableSubmitBtn(false);

        }

    }

    const selecteditarray = async (objedit, editSection) => {

        try {

            if (editSection == "Passport") {
                let responsedata = await getEmployeePassportInfo(objedit);
                seteditArray(responsedata.data.ResponseData[0]);

                if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData[0].length != 0) {

                    let issuedate = moment(new Date(responsedata.data.ResponseData[0][0].date_of_issue));
                    let olddateofissue = issuedate.format("YYYY-MM-DD");

                    let expirydate = moment(new Date(responsedata.data.ResponseData[0][0].date_of_expiry));
                    let olddateofexpiry = expirydate.format("YYYY-MM-DD");

                    let oldvalueobj = {

                        NameInPassport: responsedata.data.ResponseData[0][0].name_in_passport,
                        PassportNumber: responsedata.data.ResponseData[0][0].passport_num,
                        DateOfIssue: olddateofissue,
                        DateOfExpiry: olddateofexpiry,
                        PlaceOfIssue: responsedata.data.ResponseData[0][0].place_of_issue,
                        Ecnr: responsedata.data.ResponseData[0][0].ecnr
                    };
                    setOldvalue(oldvalueobj);

                    let dateofissue = issuedate.format("YYYY-MM-DD");
                    let dateofexpiry = expirydate.format("YYYY-MM-DD");

                    let valiDateobj1 = {
                        id: responsedata.data.ResponseData[0][0].id,
                        NameInPassport: responsedata.data.ResponseData[0][0].name_in_passport,
                        PassportNumber: responsedata.data.ResponseData[0][0].passport_num,
                        DateOfIssue: dateofissue,
                        DateOfExpiry: dateofexpiry,
                        PlaceOfIssue: responsedata.data.ResponseData[0][0].place_of_issue,
                        Ecnr: responsedata.data.ResponseData[0][0].ecnr
                    };
                    setpassportData(valiDateobj1);
                }
            }

            if (editSection == "Visa") {

                let responsedata = await getEmployeeVisaInfo(objedit);

                if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData[0].length != 0) {

                    let issuedate = moment(new Date(responsedata.data.ResponseData[0][0].date_of_issue));
                    let olddateofissue = issuedate.format("YYYY-MM-DD");

                    let expirydate = moment(new Date(responsedata.data.ResponseData[0][0].date_of_expiry));
                    let olddateofexpiry = expirydate.format("YYYY-MM-DD");

                    let oldvalueobj = {

                        VisaNumber: responsedata.data.ResponseData[0][0].visa_number,
                        VisaType: responsedata.data.ResponseData[0][0].visa_type,
                        DateOfIssue: olddateofissue,
                        DateOfExpiry: olddateofexpiry,
                        Country: responsedata.data.ResponseData[0][0].country
                    };
                    setOldVisa(oldvalueobj);

                    let valiDateobj1 = {
                        id: responsedata.data.ResponseData[0][0].id,
                        VisaNumber: responsedata.data.ResponseData[0][0].visa_number,
                        VisaType: responsedata.data.ResponseData[0][0].visa_type,
                        DateOfIssue: olddateofissue,
                        DateOfExpiry: olddateofexpiry,
                        Country: responsedata.data.ResponseData[0][0].country
                    };
                    setVisaDetail(valiDateobj1);
                }

            }

            // notification

            let NotaficationData = await getNotificationId(objedit);
            setNotification(NotaficationData.data.ResponseData[0]);
            setReportstoId(NotaficationData?.data?.ResponseData[0][0]?.emp_id);


        } catch (e) {

        }
    };
    return (
        <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }}
            hidden={hideForm}
            //id="PassportDetailsPopup" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="PassportDetailsLabel" aria-hidden="true"
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        {showPassport ? (
                            <h5 className="modal-title profile-popup-header" id="PassportDetailsLabel">
                                Passport Details
                            </h5>
                        ) : null}
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => cancelClick()}
                        />
                    </div>
                    <div
                        // className="modal-body"
                        className={showPassport && showVisa ? 'modal-body employeeInfoScroll' : 'modal-body'}
                    >
                        {showPassport ? (
                            <div>
                                <div className="row mb-0">
                                    <div className="col-md-6  mb-4">
                                        <label htmlFor="passportdetails-name" className="form-label hive-form-label">
                                            Name as in Passport<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="passportdetails-name"
                                            aria-describedby="Passport Name"
                                            placeholder="Enter here"
                                            maxLength={225}
                                            name="NameInPassport"
                                            value={passportData.NameInPassport}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        />
                                        {message.NameInPassport ? (
                                            <label className="hive-form-mandatory">{message.NameInPassport}</label>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6  mb-4">
                                        <label htmlFor="passportdetails-passport#" className="form-label hive-form-label">
                                            Passport Number<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="passportdetails-passport#"
                                            aria-describedby="Passport #"
                                            placeholder="Enter here"
                                            maxLength={9}
                                            name="PassportNumber"
                                            value={passportData.PassportNumber}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        />
                                        {message.PassportNumber ? (
                                            <label className="hive-form-mandatory">{message.PassportNumber}</label>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="row mb-0">
                                    <div className="col-md-6 ">
                                        <div className="row">
                                            <div className="col-md-6  mb-4">
                                                <label htmlFor="passportdetails-date-issue" className="form-label hive-form-label">
                                                    Date of Issue<span className="hive-form-mandatory">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control hive-form-control"
                                                    id="passportdetails-date-issue"
                                                    aria-describedby="Date Issued"
                                                    name="DateOfIssue"
                                                    value={passportData.DateOfIssue}
                                                    onChange={(e) => {
                                                        OnChangeName(e);
                                                    }}
                                                />
                                                {message.DateOfIssue ? (
                                                    <label className="hive-form-mandatory">{message.DateOfIssue}</label>
                                                ) : null}
                                            </div>
                                            <div className="col-md-6  mb-4">
                                                <label htmlFor="passportdetails-expiry" className="form-label hive-form-label">
                                                    Date of Expiry<span className="hive-form-mandatory">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control hive-form-control"
                                                    id="passportdetails-expiry"
                                                    aria-describedby="Expiry"
                                                    name="DateOfExpiry"
                                                    value={passportData.DateOfExpiry}
                                                    onChange={(e) => {
                                                        OnChangeName(e);
                                                    }}
                                                />
                                                {message.DateOfExpiry ? (
                                                    <label className="hive-form-mandatory">{message.DateOfExpiry}</label>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6  mb-4">
                                        <label htmlFor="passportdetails-place-issue" className="form-label hive-form-label">
                                            Place of Issue<span className="hive-form-mandatory">*</span>
                                        </label>

                                        <select
                                            className="form-select hive-form-select"
                                            aria-label="Default select example"
                                            id="dependant-employment-type"
                                            name="PlaceOfIssue"
                                            value={passportData.PlaceOfIssue}
                                            onChange={(e) => {
                                                OnChangeName(e);
                                            }}
                                        >
                                            <option value="select">select</option>
                                            {buildPlaceOfIssue()}
                                        </select>
                                        {message.PlaceOfIssue ? (
                                            <label className="hive-form-mandatory">{message.PlaceOfIssue}</label>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-md-6  mb-4">
                                        <label htmlFor="passportdetails-ECNR" className="form-label hive-form-label w-100">
                                            ECNR
                                        </label>
                                        <div className="form-check form-check-inline mt-2">
                                            <input
                                                className="form-check-input hive-form-check-input"
                                                type="radio"
                                                id="Stamped"
                                                checked={passportData.Ecnr == 'Stamped' ? 1 : 0}
                                                name="Ecnr"
                                                value={passportData.Ecnr}
                                                onClick={(e) => {
                                                    OnClickEcnr(e);
                                                }}
                                            />
                                            <label className="form-check-label hive-form-check-label" htmlFor="Stamped">
                                                Stamped
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline mt-2">
                                            <input
                                                className="form-check-input hive-form-check-input"
                                                type="radio"
                                                id="Yet to Stamp"
                                                checked={passportData.Ecnr == 'Yet to Stamp' ? 1 : 0}
                                                name="Ecnr"
                                                value={passportData.Ecnr}
                                                onClick={(e) => {
                                                    OnClickEcnr(e);
                                                }}
                                            />
                                            <label className="form-check-label hive-form-check-label" htmlFor="Yet to Stamp">
                                                Yet to Stamp
                                            </label>
                                        </div>
                                        {message.Ecnr ? (
                                            <label className="hive-form-label w-100 hive-form-mandatory">{message.Ecnr}</label>
                                        ) : null}
                                    </div>
                                </div>

                                {showCheckBox ? (
                                    <div className="row mb-4">
                                        <div className="col-md-12">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input hive-form-check-input"
                                                    type="checkbox"
                                                    id="do-you-have-visa"
                                                    name="doyouhavevisa"
                                                    checked={passportData.doyouhavevisa}
                                                    value={passportData.doyouhavevisa}
                                                    onChange={(e) => {
                                                        handleChecked(e);
                                                    }}
                                                />

                                                <label className="form-check-label hive-form-check-label" htmlFor="do-you-have-visa">
                                                    Do you have visa?
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : null}
                        {showVisa ? (
                            <div
                            //hidden={hideVisa}
                            >
                                <h5 className="modal-title profile-popup-header mb-4" id="VisaDetailsLabel">
                                    Visa Details
                                </h5>
                                <div className="row mb-0">
                                    <div className="col-md-6  mb-4">
                                        <label htmlFor="visadetails-num" className="form-label hive-form-label">
                                            Visa Number<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="visadetails-num"
                                            aria-describedby="Passport Name"
                                            placeholder="Enter here"
                                            maxLength={225}
                                            name="VisaNumber"
                                            value={visaDetail.VisaNumber}
                                            onChange={(e) => {
                                                VisaOnChangeName(e);
                                            }}
                                        />
                                        {errormessage.VisaNumber ? (
                                            <label className="hive-form-mandatory">{errormessage.VisaNumber}</label>
                                        ) : null}
                                    </div>
                                    <div className="col-md-6  mb-4">
                                        <label htmlFor="visa-type#" className="form-label hive-form-label">
                                            Visa Type<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="visa-type#"
                                            aria-describedby="Passport #"
                                            placeholder="Enter here"
                                            maxLength={9}
                                            name="VisaType"
                                            value={visaDetail.VisaType}
                                            onChange={(e) => {
                                                VisaOnChangeName(e);
                                            }}
                                        />
                                        {errormessage.VisaType ? (
                                            <label className="hive-form-mandatory">{errormessage.VisaType}</label>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="row mb-0">
                                    <div className="col-md-6">
                                        <div className="row">
                                            <div className="col-md-6  mb-4">
                                                <label htmlFor="visadetails-date-issue" className="form-label hive-form-label">
                                                    Date of Issue<span className="hive-form-mandatory">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control hive-form-control"
                                                    id="visadetails-date-issue"
                                                    aria-describedby="Date Issued"
                                                    name="DateOfIssue"
                                                    value={visaDetail.DateOfIssue}
                                                    onChange={(e) => {
                                                        VisaOnChangeName(e);
                                                    }}
                                                />
                                                {errormessage.DateOfIssue ? (
                                                    <label className="hive-form-mandatory">{errormessage.DateOfIssue}</label>
                                                ) : null}
                                            </div>
                                            <div className="col-md-6  mb-4">
                                                <label htmlFor="visadetails-expiry" className="form-label hive-form-label">
                                                    Date of Expiry<span className="hive-form-mandatory">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control hive-form-control"
                                                    id="visadetails-expiry"
                                                    aria-describedby="Expiry"
                                                    name="DateOfExpiry"
                                                    value={visaDetail.DateOfExpiry}
                                                    onChange={(e) => {
                                                        VisaOnChangeName(e);
                                                    }}
                                                />
                                                {errormessage.DateOfExpiry ? (
                                                    <label className="hive-form-mandatory">{errormessage.DateOfExpiry}</label>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6  mb-4">
                                        <label htmlFor="visa-country" className="form-label hive-form-label">
                                            Country<span className="hive-form-mandatory">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control hive-form-control"
                                            id="visa-country"
                                            aria-describedby="Place Issued"
                                            maxLength={50}
                                            placeholder="Enter here"
                                            name="Country"
                                            value={visaDetail.Country}
                                            onChange={(e) => {
                                                VisaOnChangeName(e);
                                            }}
                                        />

                                        {errormessage.Country ? (
                                            <label className="hive-form-mandatory">{errormessage.Country}</label>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        <div className="modal-footer border-0">
                            <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn hive-btn-primary"
                                onClick={() => {
                                    submitClick();
                                }}
                                disabled={DisableSubmitBtn}
                            >
                                {submit}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(PassportDetail)